import { CartUpdateEvent } from '@theme/events';

class giftBoxComponent extends HTMLElement {

    constructor() {

        super();
        this.form = this.querySelector('.gift-box__form');
        if (!this.form) {
            return;
        }
        this.form.addEventListener('submit', this.addToCart.bind(this));

    }

    async addToCart(event) {
        event.preventDefault();
        event.stopPropagation();
        const form = event.target;
        const submitButton = form.querySelector('[type="submit"]');

        if (submitButton) {
            submitButton.disabled = true;
        }

        if (!(form instanceof HTMLFormElement)) return;

        const formData = new FormData(form);

        const variantId = formData.get('gift-box-dropdown');

        if (!variantId) {
            console.error('No variant ID found in Gift Box form data');
            return;
        }

        const cartData = {
            items: [{
                id: parseInt(variantId),
                quantity: 1
            }]
        };

        try {
            const response = await fetch(Theme.routes.cart_add_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(cartData)
            });

            if (response.ok) {
                const data = await response.json();
                this.onAddToCartSuccess(data);
                await this.refreshCartSections();
            } else {
                const errorData = await response.json();
                console.error('Error adding gift box to cart:', errorData);
                this.onAddToCartError(errorData);
            }
        } catch (error) {
            console.error('Network error:', error);
            this.onAddToCartError(error);
        }
    }

    onAddToCartSuccess(data) {
        this.dispatchEvent(new CustomEvent('variant:added', {
            detail: { product: data },
            bubbles: true
        }));
    }

    onAddToCartError(error) {
        this.dispatchEvent(new CustomEvent('cart:error', {
            detail: { error: error },
            bubbles: true
        }));
    }


    // Refresh the cart sections after adding the gift box to the cart.
    async refreshCartSections() {
        try {
            const response = await fetch(Theme.routes.cart_url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                this.dispatchEvent(new CartUpdateEvent({}, 'gift-box-component', data));
            } else {
                console.error('Error refreshing cart sections:', response.statusText);
            }
        } catch (error) {
            console.error('Error refreshing cart sections:', error);
        }
    }

}

if (!window.customElements.get('gift-box-component')) {
    window.customElements.define('gift-box-component', giftBoxComponent);
}